/**
 * Converte URL relativa do ícone em absoluta.
 * @param {string} url - URL do ícone (pode ser relativa, ex: /uploads/icon.png)
 * @param {string} baseUrl - base URL da API (ex: axios.defaults.baseURL)
 * @returns {string} URL absoluta ou original se já for absoluta
 */
export const toAbsoluteIconUrl = (url, baseUrl) => {
  if (!url || typeof url !== 'string') return url
  const trimmed = url.trim()
  if (!trimmed) return trimmed
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
    return trimmed
  }
  if (!baseUrl || typeof baseUrl !== 'string') return trimmed
  const baseNorm = baseUrl.replace(/\/$/, '')
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
  return `${baseNorm}${path}`
}

export const resolveIcon = (assetType, iconUrl) => {
  const url = iconUrl != null ? String(iconUrl).trim() : ''
  if (url && url.length > 0) {
    return url
  }

  const assetIcons = {
    1: 'Car.png',
    2: 'Motorcycle.png',
    3: 'Truck.png',
    4: 'TruckTractor.png',
    5: 'Van.png',
    6: 'Bus.png',
    7: 'Pickup.png',
    8: 'Excavator.png',
    9: 'Grader.png',
    10: 'WheelLoader.png',
    11: 'Dozer.png',
    12: 'BackhoeLoader.png',
    13: 'SkidSteerLoader.png',
    14: 'Boat.png',
    15: 'JetSki.png',
    16: 'BoxTruck.png',
    17: 'MixerTruck.png',
    18: 'WaterTruck.png',
    19: 'CraneTruck.png',
    20: 'RoadRoller.png',
    21: 'ForkLift.png',
    22: 'ScissorLift.png',
    23: 'ForkLiftCabin.png',
    24: 'ContainerLifter.png',
    25: 'ArticulatedLift.png',
    26: 'CombineHarvester.png',
    27: 'SealcoatTruck.png',
    28: 'IrrigationPivot.png',
    29: 'SecurityHelmet.png',
    30: 'CropSprayer.png',
    36: 'StationaryEngine.png',
    37: 'DumpTruck.png',
    40: 'energy-tower.png',
  };

  const typeId = assetType != null ? Number(assetType) : null
  const iconName = (typeId != null && !Number.isNaN(typeId) && assetIcons[typeId]) ? assetIcons[typeId] : 'Car.png'

  return require(`@/assets/images/assets/${iconName}`);
};

export const getAvailableAssetTypes = () => {
  const assetIcons = {
    1: 'Car.png',
    2: 'Motorcycle.png',
    3: 'Truck.png',
    4: 'TruckTractor.png',
    5: 'Van.png',
    6: 'Bus.png',
    7: 'Pickup.png',
    8: 'Excavator.png',
    9: 'Grader.png',
    10: 'WheelLoader.png',
    11: 'Dozer.png',
    12: 'BackhoeLoader.png',
    13: 'SkidSteerLoader.png',
    14: 'Boat.png',
    15: 'JetSki.png',
    16: 'BoxTruck.png',
    17: 'MixerTruck.png',
    18: 'WaterTruck.png',
    19: 'CraneTruck.png',
    20: 'RoadRoller.png',
    21: 'ForkLift.png',
    22: 'ScissorLift.png',
    23: 'ForkLiftCabin.png',
    24: 'ContainerLifter.png',
    25: 'ArticulatedLift.png',
    26: 'CombineHarvester.png',
    27: 'SealcoatTruck.png',
    28: 'IrrigationPivot.png',
    29: 'SecurityHelmet.png',
    30: 'CropSprayer.png',
    36: 'StationaryEngine.png',
    37: 'DumpTruck.png',
    40: 'energy-tower.png',
  };

  return Object.entries(assetIcons).map(([id, iconName]) => ({
    id: parseInt(id),
    iconName
  }));
};


